// src/services/gamificationService.js - FIXED VERSION - Single Source of Truth
import { db, auth } from '../firebase';
import { doc, getDoc, updateDoc, serverTimestamp, increment } from 'firebase/firestore';
import enhancedUserService from '../services/enhancedUserService.js';

class GamificationService {
  constructor() {
    this.userCollectionPath = 'users';
  }

  async getUserGameData(userId) {
    try {
      const userRef = doc(db, this.userCollectionPath, userId);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();

        // FIXED: Always read from stats.currentStreak as the single source of truth
        return {
          studyStreak: userData.stats?.currentStreak || 0, // Return as studyStreak for component compatibility
          dailyXP: userData.dailyXP || 0,
          totalXP: userData.totalXP || 0,
          achievements: userData.achievements || [],
          lastActiveDate: userData.lastStudyDate,
          // Include full stats for components that need detailed data
          stats: userData.stats || {}
        };
      }

      return this.getDefaultGameData();
    } catch (error) {
      console.error('Error getting user game data:', error);
      return this.getDefaultGameData();
    }
  }

  getDefaultGameData() {
    return {
      studyStreak: 0,
      dailyXP: 0,
      totalXP: 0,
      achievements: [],
      lastActiveDate: null,
      stats: {}
    };
  }

  async awardXP(userId, amount, category = 'grammar') {
    try {
      const userRef = doc(db, this.userCollectionPath, userId);

      // Update XP and mark study activity
      await updateDoc(userRef, {
        dailyXP: increment(amount),
        totalXP: increment(amount),
        lastStudyDate: serverTimestamp(),
        updatedAt: serverTimestamp()
      });

      return await this.getUserGameData(userId);
    } catch (error) {
      console.error('Error awarding XP:', error);
      throw error;
    }
  }

  // REMOVED: updateStreak method - now delegated to enhancedUserService
  // This prevents multiple sources of truth

  async initializeUserGameData(userId) {
    try {
      const userRef = doc(db, this.userCollectionPath, userId);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();
        const updates = {};

        // Initialize stats object if it doesn't exist
        if (!userData.stats) {
          updates.stats = {
            currentStreak: userData.stats?.currentStreak || userData.studyStreak || 0,
            longestStreak: userData.stats?.currentStreak || userData.studyStreak || 0,
            totalStudyTimeMinutes: 0,
            lessonsCompleted: 0,
            examsCompleted: 0,
            vocabularyWordsLearned: 0,
            achievementsUnlocked: 0,
            totalPoints: 0
          };
        } else {
          // Ensure currentStreak exists in stats
          if (userData.stats.currentStreak === undefined) {
            updates['stats.currentStreak'] = userData.stats?.currentStreak || userData.studyStreak || 0;
          }
          if (userData.stats.longestStreak === undefined) {
            updates['stats.longestStreak'] = uuserData.stats?.currentStreak || userData.studyStreak || 0;
          }
        }

        // Initialize other game fields
        if (userData.dailyXP === undefined) updates.dailyXP = 0;
        if (userData.totalXP === undefined) updates.totalXP = 0;
        if (userData.achievements === undefined) updates.achievements = [];

        if (Object.keys(updates).length > 0) {
          await updateDoc(userRef, {
            ...updates,
            updatedAt: serverTimestamp()
          });
          console.log('Initialized game data fields for user:', userId);
        }
      }
    } catch (error) {
      console.error('Error initializing user game data:', error);
    }
  }

  async checkAndAwardAchievements(userId) {
    // Implementation remains the same - delegates to enhancedUserService for consistency
    return await enhancedUserService.checkAndAwardAchievements?.(userId);
  }
}

export default new GamificationService();